import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import Cell from 'modules/time_planning/components/Cell'
import CollectionsBootstrap from 'modules/time_planning/lib/ProfileCollectionsBootstrap'
import { RouteProvider } from 'modules/time_planning/lib/RouteContext'

const Container = observer(() => {
  const { navigation } = useNavigation()

  return (
    <RouteProvider
      baseRoute={{
        planningVersions: (planningVersionId) =>
          navigation.profile.planningVersions.planningVersionId.fullPath({
            planningVersionId,
          }),
        index: () => navigation.profile.planningVersions.fullPath(),
      }}
    >
      <Cell />
    </RouteProvider>
  )
})

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
